export default __webpack_public_path__ + "static/media/logo-app-name_en.577073db.svg";